<div *ngIf="uploads && uploads.length > 0">
  <div *ngFor="let item of uploads">
    <div fxLayout="column" fxFlexAlign="stretch" fxLayoutGap="1rem">
      <div fxLayout="row" fxFlexAlign="stretch">
        <div fxFlex="100">
          <p>{{ item.displayName }}:</p>
        </div>
        <div fxFlex="100">
          <a target="_blank" href="{{ item.url }}" download="{{ item.displayName }}">
            {{ item.displayName }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
